export const REACT_APP_DEV_REDIRECT_URL = "https://dev.hillsretailorder.com/";
export const REACT_APP_TST_REDIRECT_URL = "https://stageaem.hillsvet.com/";
export const REACT_APP_PRD_REDIRECT_URL = "https://www.hillsvet.com/";